package article.spring

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.animateIntOffsetAsState
import androidx.compose.animation.core.animateOffsetAsState
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.gestures.detectDragGestures
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.draw.scale
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerInputChange
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import kotlin.math.roundToInt


const val SPRING_DRAG = "b0da1a569ad71896e2b105118be445872ac33a963269c2bf0d23506e2bc8f475"

@Composable
fun SpringDrag() {

    SpringGrid {
        var isBeingDragged by remember { mutableStateOf(false) }
        var offset by remember { mutableStateOf(IntOffset.Zero) }
        var showHint by remember { mutableStateOf(true) }

        val animatedOffset by animateIntOffsetAsState(
            targetValue = offset,
            animationSpec = if (isBeingDragged)
                spring(
                    stiffness = Spring.StiffnessMedium,
                    dampingRatio = Spring.DampingRatioMediumBouncy
                )
            else
                spring(
                    stiffness = Spring.StiffnessVeryLow,
                    dampingRatio = Spring.DampingRatioMediumBouncy
                )
        )

        val scale by animateFloatAsState(
            targetValue = if (isBeingDragged) .7f else 1f,
            animationSpec = if (isBeingDragged)
                spring(
                    stiffness = Spring.StiffnessMedium,
                    dampingRatio = Spring.DampingRatioMediumBouncy
                )
            else
                spring(
                    stiffness = Spring.StiffnessVeryLow,
                    dampingRatio = Spring.DampingRatioMediumBouncy
                )
        )

        Box(Modifier
            .pointerInput(Unit) {
                detectTapGestures(
                    onPress = {
                        isBeingDragged = true
                        offset = IntOffset(
                            (it.x - size.width / 2).roundToInt(),
                            (it.y - size.height / 2).roundToInt()
                        )
                        awaitRelease()
                        isBeingDragged = false
                        offset = IntOffset.Zero
                    }
                )
            }
            .pointerInput(Unit) {
                detectDragGestures(
                    onDragStart = {
                        isBeingDragged = true
                        showHint = false
                        offset = IntOffset(
                            (it.x - size.width / 2).roundToInt(),
                            (it.y - size.height / 2).roundToInt()
                        )
                    },
                    onDragEnd = {
                        isBeingDragged = false
                        offset = IntOffset.Zero
                    },
                ) { _: PointerInputChange, dragAmount: Offset ->
                    offset += IntOffset(dragAmount.x.toInt(), dragAmount.y.toInt())
                }
            }
            .fillMaxSize()
        ) {

            Orb(
                Modifier
                    .align(Alignment.Center)
                    .offset { animatedOffset }
                    .scale(scale)
                    .size(100.dp),
                glow = isBeingDragged,
            )

            InfoBox(
                text = "Click and drag me",
                show = showHint,
                modifier = Modifier
                    .offset(y = (-10).dp)
                    .align(Alignment.BottomCenter)
            )

        }
    }
}

@Composable
fun InfoBox(
    text: String,
    show: Boolean,
    modifier: Modifier = Modifier,
) {

    AnimatedVisibility(
        visible = show,
        modifier = modifier,
        enter = fadeIn(spring(stiffness = Spring.StiffnessVeryLow)) + slideInVertically(
            spring(stiffness = Spring.StiffnessVeryLow)
        ) { it },
        exit = fadeOut(spring(stiffness = Spring.StiffnessVeryLow)) + slideOutVertically(
            spring(stiffness = Spring.StiffnessVeryLow)
        ) { it / 2 }
    ) {
        Box(
            Modifier.border(1.dp, Color.Gray, shape = RoundedCornerShape(5.dp))
                .padding(horizontal = 12.dp, vertical = 8.dp)
        ) {
            Text(text)
        }
    }


}